import { db } from "@/main";
import { ExternalSystem } from "@/data/models/ExternalSystem";
import { getClientId, setClientInfo } from "./ClientRepository";
import { createDefaultHyDryMessagesSettings } from "../models/HyDryMessagesConfig";
import { viewExternalSystemsAccess } from "@/permissions/UserPermissions";
import { getEffectiveUserLazily } from "@/utils/EffectiveUserLazy";

function getExternalSystemRef(id: string) {
  return db.collection("externalSystems").doc(id);
}

async function getExternalSystem(id: string) {
  return (await getExternalSystemRef(id).get()).data() as ExternalSystem;
}

export async function loadExternalSystem() {
  const externalSystem = await getExternalSystem(getClientId());

  if (!externalSystem) {
    return null;
  }

  setClientInfo({
    hyDryMessageSettings: createDefaultHyDryMessagesSettings(),
    branches: [],
    hasApp: externalSystem.targetClientHasApp == true,
    targetAppVersion: 100000,
    isExternalSystem: true,
    targetClientId: externalSystem.targetClientId,
    isIresClient: false,
    clientName: externalSystem.name,
    logoFile: null,
    zipCode: "",
    companyName: "",
    city: "",
    street: "",
    houseNumber: "",
    syncsProjectWithErp: false,
    minProgramChainDurationInMin: 0,
    visibleTo: []
  });

  return externalSystem;
}

export async function getExternalSystemsOfClient() {
  const clientId = getClientId();
  const externalSystems: ExternalSystem[] = []; 
  const user = getEffectiveUserLazily();

  if (
    !user || 
    !viewExternalSystemsAccess(user)
  ) {
    return externalSystems;
  }

  return (
    await db
      .collection("externalSystems")
      .where("targetClientId", "==", clientId)
      .get()
  ).docs.map((doc) => doc.data() as ExternalSystem);
}
